export const FormTypes = {
  Adventure: "Adventure",
  UpdateAdventure: "UpdateAdventure",
  DeleteAdventure: "DeleteAdventure",
  Destination: "Destination",
  UpdateDestination: "UpdateDestination",
  DeleteDestination: "DeleteDestination",
  DestinationImage: "DestinationImage",

  Programme: "Programme",
};

export const createFormConfig = (option) => {
  switch (option) {
    case FormTypes.Adventure:
      return {
        fields: [
          {
            name: "destinationId",
            label: "Destination",
            type: "select",
            options: "destinations",
            required: true,
            placeholder: "Choose the destination",
          },
          {
            name: "startDate",
            label: "Start Date",
            type: "date",
            required: true,
          },
          { name: "endDate", label: "End Date", type: "date", required: true },
          {
            name: "itinerary",
            label: "Itinerary",
            type: "textarea",
            required: true,
            placeholder: "Enter the itinerary",
          },
        ],
        groupedFields: [
          {
            name: "priceGroups",
            label: "Price",
            type: "group",
            fields: [
              {
                name: "group",
                label: "Group",
                type: "select",
                required: true,
                placeholder: "Choose Group",
                class: "custom-form__group-item__field--m",
                options: [
                  { label: "Citizens", value: "citizens" },
                  { label: "Residents", value: "residents" },
                  { label: "Non-Residents", value: "nonResidents" },
                  {
                    label: "Kenyan And East Africa Citizen",
                    value: "kenyanAndEastAfricaCitizen",
                  },
                  {
                    label: "Citizens And Residents",
                    value: "citizensAndResidents",
                  },
                ],
              },
              {
                name: "amount",
                label: "Amount",
                type: "number",
                required: true,
                placeholder: "Enter Amount",
                class: "custom-form__group-item__field--sm",
              },
              {
                name: "currency",
                label: "Currency",
                type: "select",
                options: "currencies",
                required: true,
                placeholder: "Enter Amount",
                class: "custom-form__group-item__field--m",
              },
            ],
            defaultValue: [{ group: "", amount: 0 }],
          },
          {
            name: "paymentPlan",
            label: "Payment Plan",
            type: "group",
            fields: [
              {
                name: "installment",
                label: "Installment",
                type: "select",
                required: true,
                options: [
                  {
                    label: "1st Installment(Booking Fee)",
                    value: "bookingFee",
                  },
                  { label: "2nd Installment", value: "2ndInstallment" },
                  { label: "3rd Installment", value: "3rdInstallment" },
                  { label: "4th Installment", value: "4thInstallment" },
                  { label: "5th Installment", value: "5thInstallment" },
                ],
              },
              {
                name: "percentage",
                label: "Percentage of the initial cost",
                type: "number",
                required: true,
                placeholder: "Enter percentage",
                max: 100,
              },
            ],
            defaultValue: [{ description: "", percentage: 0 }],
          },
        ],
      };

    case FormTypes.UpdateAdventure:
      return {
        fields: [
          {
            name: "adventureId",
            label: "Adventure",
            type: "hidden",
            required: true,
            placeholder: "Choose the destination",
          },
          // {
          //   name: "destinationId",
          //   label: "Destination",
          //   type: "select",
          //   options: "destinations",
          //   required: true,
          //   placeholder: "Choose the destination",
          // },
          {
            name: "startDate",
            label: "Start Date",
            type: "date",
            required: true,
          },
          { name: "endDate", label: "End Date", type: "date", required: true },
          {
            name: "itinerary",
            label: "Itinerary",
            type: "textarea",
            required: true,
            placeholder: "Enter the itinerary",
          },
        ],
        groupedFields: [
          {
            name: "priceGroups",
            label: "Price",
            type: "group",
            fields: [
              {
                name: "group",
                label: "Group",
                type: "select",
                required: true,
                placeholder: "Choose Group",
                class: "custom-form__group-item__field--m",
                options: [
                  { label: "Citizens", value: "citizens" },
                  { label: "Residents", value: "residents" },
                  { label: "Non-Residents", value: "nonResidents" },
                  {
                    label: "Kenyan And East Africa Citizen",
                    value: "kenyanAndEastAfricaCitizen",
                  },
                  {
                    label: "Citizens And Residents",
                    value: "citizensAndResidents",
                  },
                ],
              },
              {
                name: "amount",
                label: "Amount",
                type: "number",
                required: true,
                placeholder: "Enter Amount",
                class: "custom-form__group-item__field--sm",
              },
              {
                name: "currency",
                label: "Currency",
                type: "select",
                options: "currencies",
                required: true,
                placeholder: "Enter Amount",
                class: "custom-form__group-item__field--m",
              },
            ],
            defaultValue: [{ group: "", amount: 0 }],
          },
          {
            name: "paymentPlan",
            label: "Payment Plan",
            type: "group",
            fields: [
              {
                name: "installment",
                label: "Installment",
                type: "select",
                required: true,
                options: [
                  {
                    label: "1st Installment(Booking Fee)",
                    value: "bookingFee",
                  },
                  { label: "2nd Installment", value: "2ndInstallment" },
                  { label: "3rd Installment", value: "3rdInstallment" },
                  { label: "4th Installment", value: "4thInstallment" },
                  { label: "5th Installment", value: "5thInstallment" },
                ],
              },
              {
                name: "percentage",
                label: "Percentage of the initial cost",
                type: "number",
                required: true,
                placeholder: "Enter percentage",
                max: 100,
              },
            ],
            defaultValue: [{ description: "", percentage: 0 }],
          },
        ],
      };

    case FormTypes.DeleteAdventure:
      return {
        fields: [
          {
            name: "adventureId",
            label: "Adventure",
            type: "hidden",
            // options: "destinations",
            required: true,
            placeholder: "Choose the Adventure",
            disabled: true,
          },
        ],
      };

    case FormTypes.Destination:
      return {
        fields: [
          {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            placeholder: "Enter Destination Name",
          },
          {
            name: "type",
            label: "Type",
            type: "select",
            required: true,
            placeholder: "choose destination type",
            options: [
              { label: "Day Hike", value: "1" },
              { label: "Over Night", value: "2" },
              { label: "Mountaineering", value: "3" },
            ],
          },
          {
            name: "duration",
            label: "Duration",
            type: "number",
            required: true,
            placeholder: "Enter duration",
          },
          {
            name: "durationUnits",
            label: "Duration Unit",
            type: "select",
            options: [
              { label: "Hour(s)", value: "hours" },
              { label: "Days", value: "days" },
            ],
            required: true,
            placeholder: "select duration units",
          },
          {
            name: "maxElevation",
            label: "Max Elevation",
            type: "number",
            required: true,
            placeholder: "Eneter Max Elevation",
          },
          {
            name: "elevationGain",
            label: "Elevation Gain",
            type: "number",
            required: true,
            placeholder: "Eneter Elevation Gain",
          },
          {
            name: "distanceInKm",
            label: "Distance(km)",
            type: "number",
            required: true,
            placeholder: "Enter the distance in km",
          },
          {
            name: "country",
            label: "Country",
            type: "select",
            options: "countries",
            required: true,
            placeholder: "choose country",
          },
          {
            name: "location",
            label: "Location",
            type: "text",
            required: true,
            placeholder: "enter destination location",
          },
          {
            name: "description",
            label: "Description",
            type: "textarea",
            required: true,
            placeholder: "describe the destination",
          },
          {
            name: "difficulty",
            label: "Difficulty",
            type: "select",
            required: true,
            placeholder: "choose difficulty",
            options: [
              { label: "Beginner Friendly", value: "1" },
              { label: "Moderate", value: "2" },
              { label: "Challenging", value: "3" },
              { label: "Very Hard", value: "3" },
            ],
          },
          {
            name: "isChildFriendly",
            label: "Is ChildFriendly ?",
            type: "radio",
            options: [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ],
          },
          {
            name: "isTraverse",
            label: "Is Traverse ?",
            type: "radio",
            options: [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ],
          },
          {
            name: "destinationIds",
            label: "Destinations In The Traverse",
            type: "selectMany",
            options: "destinations",
            required: true,
            placeholder: "select destinations in the traverse",
            showIf: (formData) => formData["isTraverse"] === "true",
          },
        ],
      };

    case FormTypes.UpdateDestination:
      return {
        fields: [
          {
            name: "destinationId",
            label: "Destination",
            type: "hidden",
            // options: "destinations",
            required: true,
            placeholder: "Choose the destination",
            disabled: true,
          },
          {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            placeholder: "Enter Destination Name",
          },
          {
            name: "type",
            label: "Type",
            type: "select",
            required: true,
            placeholder: "choose destination type",
            options: [
              { label: "Day Hike", value: "1" },
              { label: "Over Night", value: "2" },
              { label: "Mountaineering", value: "3" },
            ],
          },
          {
            name: "duration",
            label: "Duration",
            type: "number",
            required: true,
            placeholder: "Enter duration",
          },
          {
            name: "durationUnits",
            label: "Duration Unit",
            type: "select",
            options: [
              { label: "Hour(s)", value: "hours" },
              { label: "Days", value: "days" },
            ],
            required: true,
            placeholder: "select duration units",
          },
          {
            name: "maxElevation",
            label: "Max Elevation",
            type: "number",
            required: true,
            placeholder: "Eneter Max Elevation",
          },
          {
            name: "elevationGain",
            label: "Elevation Gain",
            type: "number",
            required: true,
            placeholder: "Eneter Elevation Gain",
          },
          {
            name: "distanceInKm",
            label: "Distance(km)",
            type: "number",
            required: true,
            placeholder: "Enter the distance in km",
          },
          {
            name: "country",
            label: "Country",
            type: "select",
            options: "countries",
            required: true,
            placeholder: "choose country",
          },
          {
            name: "location",
            label: "Location",
            type: "text",
            required: true,
            placeholder: "enter destination location",
          },
          {
            name: "description",
            label: "Description",
            type: "textarea",
            required: true,
            placeholder: "describe the destination",
          },
          {
            name: "difficulty",
            label: "Difficulty",
            type: "select",
            required: true,
            placeholder: "choose difficulty",
            options: [
              { label: "Beginner Friendly", value: "1" },
              { label: "Moderate", value: "2" },
              { label: "Challenging", value: "3" },
              { label: "Very Hard", value: "3" },
            ],
          },
          {
            name: "isChildFriendly",
            label: "Is ChildFriendly ?",
            type: "radio",
            options: [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ],
          },
          {
            name: "isTraverse",
            label: "Is Traverse ?",
            type: "radio",
            options: [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ],
          },
          {
            name: "destinationIds",
            label: "Destinations In The Traverse",
            type: "selectMany",
            options: "destinations",
            required: true,
            placeholder: "select destinations in the traverse",
            showIf: (formData) => formData["isTraverse"] === "true",
          },
        ],
      };

    case FormTypes.DeleteDestination:
      return {
        fields: [
          {
            name: "destinationId",
            label: "Destination",
            type: "hidden",
            // options: "destinations",
            required: true,
            placeholder: "Choose the destination",
            disabled: true,
          },
        ],
      };

    case FormTypes.DestinationImage:
      return {
        fields: [
          {
            name: "destinationId",
            label: "Destination",
            type: "select",
            options: "destinations",
            required: true,
            placeholder: "Choose the destination",
            disabled: true,
          },
          {
            name: "imageValue",
            label: "Image",
            type: "file",
            required: true,
            placeholder: "choose an image",
            accept: "image/*",
          },
          {
            name: "caption",
            label: "Image Caption",
            type: "text",
            required: true,
            placeholder: "Enter image caption",
          },
          {
            name: "isDisplayImage",
            label: "Is Display Image?",
            type: "radio",
            options: [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ],
          },
        ],
      };

    case FormTypes.Programme:
      return {
        fields: [
          {
            name: "startDate",
            label: "Start Date",
            type: "date",
            required: true,
          },
          { name: "endDate", label: "End Date", type: "date", required: true },
          {
            name: "description",
            label: "Description",
            type: "textarea",
            required: true,
            placeholder: "Enter the description",
          },
          {
            name: "duration",
            label: "Duration",
            type: "number",
            required: true,
            placeholder: "Enter duration",
          },
          {
            name: "durationUnits",
            label: "Duration Unit",
            type: "select",
            options: [
              { label: "Hour(s)", value: "hours" },
              { label: "Days", value: "days" },
            ],
            required: true,
            placeholder: "select duration units",
          },

          {
            name: "adventureIds",
            label: "Adventure In The Programme",
            type: "selectMany",
            options: "adventures",
            required: true,
            placeholder: "select adventures in the programme",
            // showIf: (formData) => formData["isTraverse"] === "true",
          },
        ],
        groupedFields: [
          {
            name: "price",
            label: "Price",
            type: "group",
            fields: [
              {
                name: "group",
                label: "Group",
                type: "select",
                required: true,
                placeholder: "Choose Group",
                class: "custom-form__group-item__field--m",
                options: [
                  { label: "Citizens", value: "citizens" },
                  { label: "Residents", value: "residents" },
                  { label: "Non-Residents", value: "nonResidents" },
                  {
                    label: "Kenyan And East Africa Citizen",
                    value: "kenyanAndEastAfricaCitizen",
                  },
                  {
                    label: "Citizens And Residents",
                    value: "citizensAndResidents",
                  },
                ],
              },
              {
                name: "amount",
                label: "Amount",
                type: "number",
                required: true,
                placeholder: "Enter Amount",
                class: "custom-form__group-item__field--sm",
              },
              {
                name: "currency",
                label: "Currency",
                type: "select",
                options: "currencies",
                required: true,
                placeholder: "Enter Amount",
                class: "custom-form__group-item__field--m",
              },
            ],
            defaultValue: [{ group: "", amount: 0 }],
          },
          {
            name: "paymentPlan",
            label: "Payment Plan",
            type: "group",
            fields: [
              {
                name: "installment",
                label: "Installment",
                type: "select",
                required: true,
                options: [
                  {
                    label: "1st Installment(Booking Fee)",
                    value: "bookingFee",
                  },
                  { label: "2nd Installment", value: "2ndInstallment" },
                  { label: "3rd Installment", value: "3rdInstallment" },
                  { label: "4th Installment", value: "4thInstallment" },
                  { label: "5th Installment", value: "5thInstallment" },
                ],
              },
              {
                name: "percentage",
                label: "Percentage of the initial cost",
                type: "number",
                required: true,
                placeholder: "Enter percentage",
                max: 100,
              },
            ],
            defaultValue: [{ description: "", percentage: 0 }],
          },
        ],
      };

    default:
      throw new Error(`Unknown form option: ${option}`);
  }
};
